import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { useMemo, useRef } from 'react'
import { enabledAccountsTitleSelector } from 'components/features/pageFilters/selectors'


export const useEnabledAccounts = () => {

  const nextEnabledAccounts = useStoreSelector(enabledAccountsTitleSelector)
  const prevEnabledAccountsRef = useRef(nextEnabledAccounts)
  return useMemo(() => {
    if (nextEnabledAccounts.count !== 0) {
      prevEnabledAccountsRef.current = nextEnabledAccounts
      return nextEnabledAccounts
    }

    return prevEnabledAccountsRef.current
  }, [nextEnabledAccounts])
}
